var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-web-app d-flex justify-center align-center"},[_c('div',{staticClass:"lds-ellipsis"},_vm._l((4),function(i){return _c('div',{key:i})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }